import { render, staticRenderFns } from "./Contingent.vue?vue&type=template&id=c22edfa8&"
import script from "./Contingent.vue?vue&type=script&lang=js&"
export * from "./Contingent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports